import {initAccordions} from '$c3base/accordion.js';
import {initTabs} from '$c3base/tabs.js';
import {initBanner} from '$c3local/banner.js';
import {initHeader} from '$c3local/header.js';
import {initReferenceShow} from '$c3local/reference-show.js';
import {initReferenceList} from '$c3local/reference-list.js';
import {initFooter} from '$c3local/footer.js';
import {initJobList} from '$c3local/job-list.js';
import {initShareButtons} from '$c3local/share.js';
import {initFileInput} from '$c3local/file-input.js';
import {initForm} from '$c3local/form.js';
import {initCounters} from '$c3local/counter.js';
import {initReviews} from '$c3local/reviews.js';
import {initAnimations} from '$c3local/animation.js';
import {initContact} from '$c3local/contact.js';
import {initDialogs} from '$c3local/dialog.js';

initAnimations();
initAccordions({
    openClass: 'accordion--open',
});
initTabs();

initReferenceShow();
initReferenceList();
initJobList();
initBanner();
initHeader();
initFooter();
initFileInput();
initForm();
initCounters();
initReviews();
initShareButtons();
initContact();
initDialogs();